<template>
  <div>
    <v-form class="join-developer__form-col">

      <h5 class="join-developer__form-label">Availability (optional)</h5>
      <v-row class="join-developer__row">
        <v-col class="join-developer__col col-6">
          <v-select
            v-model="newDeveloper.availability.status"
            class="form-field"
            :items="featuresData.availability"
            dense
            item-color="blue"
            label="Type"
            placeholder="Choose type"
          />
        </v-col>
      </v-row>

      <v-row class="join-developer__row" v-if="isAvailableWithDateLimit">
        <v-col class="join-developer__dates join-developer__col">
          <v-menu
            ref="menuDateFrom"
            content-class="datepicker-menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <div class="form-field--date-wrapper" v-on="on">
                <v-text-field
                  v-model="newDeveloper.availability.from"
                  class="form-field mr-2"
                  label="From"
                  placeholder="Chose date"
                  dense
                  readonly
                  v-on="on"
                >
                  <template #append>
                    <v-icon color="blue">
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
            </template>
            <v-date-picker
              v-model="newDeveloper.availability.from"
              no-title
              scrollable
              :max="newDeveloper.availability.to"
              @input="$refs.menuDateFrom.save(true)"
            ></v-date-picker>
          </v-menu>

          <v-menu
            ref="menuDateTo"
            content-class="datepicker-menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <div class="form-field--date-wrapper" v-on="on">
                <v-text-field
                  v-model="newDeveloper.availability.to"
                  class="form-field ml-2"
                  label="To"
                  placeholder="Chose date"
                  dense
                  readonly
                  v-on="on"
                >
                  <template #append>
                    <v-icon color="blue">
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
            </template>

            <v-date-picker
              v-model="newDeveloper.availability.to"
              no-title
              scrollable
              :min="newDeveloper.availability.from"
              @input="$refs.menuDateTo.save(true)"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <h5 class="join-developer__form-label">Management (optional)</h5>
      <v-row class="join-developer__row">
        <v-col class="join-developer__col">
          <v-select
            v-model="newDeveloper.tools"
            class="form-field"
            :items="featuresData.tools"
            dense
            multiple
            item-color="blue"
            label="Used tools"
            placeholder="Choose your preferences"
          />
        </v-col>
      </v-row>

      <v-row class="join-developer__row">
        <v-col class="join-developer__col">
          <v-select
            v-model="newDeveloper.management"
            class="form-field"
            :items="featuresData.management"
            dense
            multiple
            item-color="blue"
            label="Management"
            placeholder="Choose your preferences"
          />
        </v-col>
      </v-row>

      <h5 class="join-developer__form-label">Finance (optional)</h5>
      <v-row class="join-developer__row">
        <v-col class="join-developer__col">
          <v-select
            v-model="newDeveloper.finance.working_hours"
            class="form-field"
            :items="featuresData.working_hours"
            dense
            multiple
            item-color="blue"
            label="Time availability"
            placeholder="Choose your preferences"
          />
        </v-col>
      </v-row>

      <v-row class="join-developer__row">
        <v-col class="join-developer__col">
          <v-select
            v-model="newDeveloper.finance.contract_types"
            class="form-field"
            :items="featuresData.contract_types"
            dense
            multiple
            item-color="blue"
            label="Type of contract"
            placeholder="Choose your contract"
          />
        </v-col>
      </v-row>

      <v-row class="join-developer__row">
        <v-col class="join-developer__col">
          <v-btn
            color="blue"
            class="join-developer__btn white--text"
            large
            width="47%"
            @click="submitStep">
            NEXT STEP
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      newDeveloper: {
        availability: {
          status: 'Available with limit',
          from: '',
          to: '',
        },

        finance: {
          working_hours: '',
          contract_types: '',
        },
      },
    };
  },

  computed: {
    ...mapState('features', [
      'featuresData',
    ]),

    isAvailableWithDateLimit() {
      return this.newDeveloper.availability.status === 'Available with limit';
    },
  },

  methods: {
    ...mapActions('developer', [
      'addDeveloperData',
    ]),

    submitStep() {
      this.addDeveloperData(this.newDeveloper);
      this.$emit('submit');
    },
  },
};
</script>

<style lang="scss" scope>
.join-developer {
  &__dates{
    display: flex;
  }
}
</style>
